import React from 'react';
import DataTable from 'react-data-table-component';

function renderDataTable(
  filteredData,
  column,
  pending,
  currentPage,
  setPageLimit,
  setCurrentPage,
  totalPages,
  pageLimit,
  setResetSearch,
) {

  return (
    <div>
      {filteredData.length > 0 ? (
        <DataTable
          data={filteredData}
          columns={column}
          className="table-bordered table-responsive"
          striped
          responsive
          progressPending={pending}
          progressComponent={<h6 className='py-10 bg-[#FFF] text-black font-bold w-full flex items-center justify-center border'>Processing data..........</h6>}
          pagination
          paginationServer
          paginationTotalRows={totalPages}
          paginationPerPage={pageLimit}
          onChangeRowsPerPage={(currentRowsPerPage, currentPage) => {
            setPageLimit(currentRowsPerPage);
            setCurrentPage(currentPage);
            setResetSearch((prevReset) => !prevReset);
          }}
          paginationDefaultPage={currentPage}
          onChangePage={(page) => { setCurrentPage(page); setResetSearch((prevReset) => !prevReset); }}
        />
      ) : (
        <>
          <div className="table-responsive" style={{ position: 'relative' }}>
            <table className='table table-bordered table-condensed all_tab' >
              <thead>
                <tr>
                  {column.map((column) => (

                    !column.omit &&
                    <th key={column.name}>{column.name}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                <tr style={{ textAlign: 'center', backgroundColor: '#f9f9f9' }}>
                  <td colSpan={column.length} style={{ padding: '8px 5px' }}>No data available in table</td>
                </tr>
              </tbody>
            </table>
            <div className="d_processing" style={{ display: pending ? 'block' : 'none' }}>Processing...</div>
          </div>
        </>
      )}
    </div>
  );
}

export default renderDataTable;

